import styles from "../ListingsFilter.module.scss"
import { Select } from "antd"
import React, { useCallback, useMemo, useState } from "react"
import { MinusSVG, PlusSVG } from "@css/icons/SVG"
import { store } from "@utils/store"
import { isBrowser } from "@utils/const"
import { DefaultOptionType } from "rc-select/lib/Select"
import cn from "classnames"

const dropdownAlign = {
    points: ["tl", "tr"],
    offset: [10, -20]
}

const dropdownAlignMobile = {
    points: ["cc", "cc"],
    offset: [10, -20]
}

type Props = {
    items: any[]
    withGroups?: boolean
    width?: number
    onItemChange: (value: string[]) => void
    title: string
    selectedItems?: string[]
}

export function TagsList(props: Props) {
    const { items, title, withGroups, onItemChange, width } = props
    const selectedItems = useMemo(() => {
        return props.selectedItems || items.filter((i) => i.selected).map((i) => i.key)
    }, [items, props.selectedItems])
    const [dropdownOpen, setDropDownOpen] = useState(false)

    const onDropdownVisibleChange = useCallback((open: boolean) => {
        setDropDownOpen(open)
    }, [])

    const Icon = dropdownOpen ? MinusSVG : PlusSVG
    const options = useMemo(() => {
        if (withGroups) {
            const groups = {} as { [k: string]: DefaultOptionType }
            items.forEach((i) => {
                if (!groups[i.group]) {
                    groups[i.group] = {
                        label: i.group,
                        options: []
                    }
                }
                groups[i.group].options.push({
                    value: i.key,
                    label: i.children || i.key
                })
            })
            return Object.values(groups)
        }
        return items.map((i) => ({
            value: i.key,
            label: i.children || i.key
        }))
    }, [items, withGroups])

    return (
        <div className={styles.filterItem}>
            <div className={styles.tagListHead}>
                <span className={styles.itemTitle}>{title}</span>
                <button className={cn(styles.selectAllBtn, !!selectedItems.length && styles.selectAllBtnActive)} onClick={() => onItemChange([])}>
                    select all
                </button>
            </div>
            <div className={styles.tagsList}>
                <Select
                    virtual={false}
                    value={selectedItems}
                    dropdownAlign={isBrowser ? (store.get("isMobile") ? dropdownAlignMobile : dropdownAlign) : dropdownAlign}
                    listHeight={400}
                    onDropdownVisibleChange={onDropdownVisibleChange}
                    mode="multiple"
                    style={style}
                    showArrow
                    dropdownMatchSelectWidth={width}
                    open={dropdownOpen}
                    placeholder={"Filter by " + title.toLowerCase()}
                    onChange={onItemChange}
                    maxTagCount={4}
                    options={options}
                    maxTagPlaceholder={(value) => "+" + value.length + " more"}
                    suffixIcon={<Icon onClick={() => onDropdownVisibleChange(!dropdownOpen)} />}
                />
            </div>
        </div>
    )
}

const style = { width: "100%" }
